import React from "react";
import { useController } from "react-hook-form";
import { Button, HStack, Input, Text, Image } from "@chakra-ui/react";

// import ErrorLabel from "./ErrorLabel";
import { toAbsoluteUrl } from "../../utils/helper";

const acceptFile = {
	image: "image/*",
	excel: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
	pdf: ".pdf",
};
export default function ImageControl({ control, name, label = "", isDisabled = false, accept = "", imgName, isRequired = false, rules }) {
	const [file, setFile] = React.useState(null);
	
	const {
		field: { value, ...field },
		// fieldState: { error },
	} = useController({
		name,
		control,
		rules: { required: isRequired && `${label} is required`, ...rules },
	});

	return (
		<>
			<HStack h="44px" w="full" border="1px solid" borderColor="inherit" borderRadius="md" outline="2px solid" outlineColor="transparent" outlineOffset="2px">
				{accept === "image" && (
					<Image
						rounded="lg"
						ml="4"
						boxSize="2rem"
						objectFit="cover"
						defaultValue={value}
						src={file ? URL.createObjectURL(file) : value}
						alt=""
						fallbackSrc={toAbsoluteUrl("/assets/default.png")}
					/>
				)}
				<Input
					isDisabled={isDisabled}
					style={{ display: "none" }}
					id="select-image"
					accept={acceptFile[accept]}
					type="file"
					{...field}
					value={value?.filename}
					onChange={(e) => {
						setFile(e.target.files[0]);
						field.onChange(e.target.files);
					}}
				/>
				<label htmlFor="select-image">
					<Button cursor="pointer" w="full" variant="outline" colorScheme="brand" size="sm" as="span">
						Choose File
					</Button>
				</label>
				<Text fontSize="sm" color="gray.400">
					{value !== undefined ? (
						<Text w={{ lg: "full", md: "50%", sm: "50%" }} whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis" color="gray.800">
							{value[0]?.name || imgName}
						</Text>
					) : (
						" Please Select"
					)}
				</Text>
			</HStack>
			{/* <ErrorLabel>{error?.message}</ErrorLabel> */}
		</>
	);
}
